import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from '../environments/environment';

declare let gtag: Function;
declare let $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Angular-Log-In-Firebase';
  version = environment.version;
  
  constructor(public router: Router){
    // Log version to console for easy checking
    console.log(`%cAL Fitness App v${environment.version}`, 'color: #4CAF50; font-weight: bold; font-size: 14px;');
    console.log(`Environment: ${environment.production ? 'Production' : 'Development'}`);
    
    this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd){
        gtag('config', 'UA-166528202-1',{'page_path': event.urlAfterRedirects});
        $('body').removeClass('sidebar-enable');
      }
    })
  }
}
